import airconditioned from "../../../../../assets/icons/amenties/airconditioned.svg";
import parking from "../../../../../assets/icons/amenties/parking.svg";
import security from "../../../../../assets/icons/amenties/security.svg";
import smokeAlarm from "../../../../../assets/icons/amenties/smokealarm.svg";
import wifi from "../../../../../assets/icons/amenties/wifi.svg";

export const featuredProperties = [
  {
    id: 1,
    title: "Best Property for you!",
    properties: [
      {
        id: 1,
        properyName: "Hotel Sea Princess",
        location: "Cox's Bazar",
        country: "Bangladesh",
        propertyRating: 4,
        price: 5500,
        discount: 10,
        images: [
          "https://cf.bstatic.com/xdata/images/hotel/max1024x768/69233653.jpg?k=c8dd85b45348243e12e1435b22c253c470f5793c18b77d57f379a6041ce1ce5e&o=",
          "https://sea-princess.bangladeshhotels.net/data/Pics/OriginalPhoto/11984/1198418/1198418227/sea-princess-hotel-cox-s-bazar-pic-4.JPEG",
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfhZF6Iueo2bSu3dKLuRFLuoMYfPvHRhY-ag&s",
        ],
        logo: "https://hoteltheseaprincess.com/wp-content/uploads/2022/01/the-sea-princess-hotel.png",
        isCoupleFriendly: true,
        isGuestChoice: false,
        isDhoorbinChoice: true,
        facilities: [
          {
            id: 1,
            icon: parking,
            name: "Parking",
          },
          {
            id: 2,
            icon: smokeAlarm,
            name: "Smoke Alarm",
          },
          {
            id: 3,
            icon: airconditioned,
            name: "Air Conditioned",
          },
          {
            id: 4,
            icon: wifi,
            name: "Wifi",
          },
          {
            id: 4,
            icon: security,
            name: "Security",
          },
        ],
        status: true,
      },
      {
        id: 2,
        properyName: "Sea Pearl Beach Resort & Spa",
        location: "Cox's Bazar",
        country: "Bangladesh",
        propertyRating: 4,
        price: 5500,
        discount: 10,
        images: [
          "https://cf.bstatic.com/xdata/images/hotel/max1024x768/69233653.jpg?k=c8dd85b45348243e12e1435b22c253c470f5793c18b77d57f379a6041ce1ce5e&o=",
          "https://sea-princess.bangladeshhotels.net/data/Pics/OriginalPhoto/11984/1198418/1198418227/sea-princess-hotel-cox-s-bazar-pic-4.JPEG",
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfhZF6Iueo2bSu3dKLuRFLuoMYfPvHRhY-ag&s",
        ],
        logo: "https://hoteltheseaprincess.com/wp-content/uploads/2022/01/the-sea-princess-hotel.png",
        isCoupleFriendly: true,
        isGuestChoice: true,
        isDhoorbinChoice: false,
        facilities: [
          {
            id: 1,
            icon: parking,
            name: "Parking",
          },
          {
            id: 2,
            icon: smokeAlarm,
            name: "Smoke Alarm",
          },
          {
            id: 3,
            icon: airconditioned,
            name: "Air Conditioned",
          },
          {
            id: 4,
            icon: wifi,
            name: "Wifi",
          },
          {
            id: 4,
            icon: security,
            name: "Security",
          },
        ],
        status: true,
      },
      {
        id: 3,
        properyName: "Hotel Sea Princess",
        location: "Cox's Bazar",
        country: "Bangladesh",
        propertyRating: 4,
        price: 5500,
        discount: 10,
        images: [
          "https://cf.bstatic.com/xdata/images/hotel/max1024x768/69233653.jpg?k=c8dd85b45348243e12e1435b22c253c470f5793c18b77d57f379a6041ce1ce5e&o=",
          "https://sea-princess.bangladeshhotels.net/data/Pics/OriginalPhoto/11984/1198418/1198418227/sea-princess-hotel-cox-s-bazar-pic-4.JPEG",
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfhZF6Iueo2bSu3dKLuRFLuoMYfPvHRhY-ag&s",
        ],
        logo: "https://hoteltheseaprincess.com/wp-content/uploads/2022/01/the-sea-princess-hotel.png",
        isCoupleFriendly: true,
        isGuestChoice: false,
        isDhoorbinChoice: true,
        facilities: [
          {
            id: 1,
            icon: parking,
            name: "Parking",
          },
          {
            id: 2,
            icon: smokeAlarm,
            name: "Smoke Alarm",
          },
          {
            id: 3,
            icon: airconditioned,
            name: "Air Conditioned",
          },
          {
            id: 4,
            icon: wifi,
            name: "Wifi",
          },
          {
            id: 4,
            icon: security,
            name: "Security",
          },
        ],
        status: true,
      },
      {
        id: 4,
        properyName: "Hotel Sea Princess",
        location: "Cox's Bazar",
        country: "Bangladesh",
        propertyRating: 4,
        price: 5500,
        discount: 10,
        images: [
          "https://cf.bstatic.com/xdata/images/hotel/max1024x768/69233653.jpg?k=c8dd85b45348243e12e1435b22c253c470f5793c18b77d57f379a6041ce1ce5e&o=",
          "https://sea-princess.bangladeshhotels.net/data/Pics/OriginalPhoto/11984/1198418/1198418227/sea-princess-hotel-cox-s-bazar-pic-4.JPEG",
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfhZF6Iueo2bSu3dKLuRFLuoMYfPvHRhY-ag&s",
        ],
        logo: "https://hoteltheseaprincess.com/wp-content/uploads/2022/01/the-sea-princess-hotel.png",
        isCoupleFriendly: true,
        isGuestChoice: false,
        isDhoorbinChoice: true,
        facilities: [
          {
            id: 1,
            icon: parking,
            name: "Parking",
          },
          {
            id: 2,
            icon: smokeAlarm,
            name: "Smoke Alarm",
          },
          {
            id: 3,
            icon: airconditioned,
            name: "Air Conditioned",
          },
          {
            id: 4,
            icon: wifi,
            name: "Wifi",
          },
          {
            id: 4,
            icon: security,
            name: "Security",
          },
        ],
        status: true,
      },
    ],
  },
  {
    id: 2,
    title: "Best Property for you!",
    properties: [
      {
        id: 1,
        properyName: "Hotel Sea Princess",
        location: "Cox's Bazar",
        country: "Bangladesh",
        propertyRating: 4,
        price: 5500,
        discount: 10,
        images: [
          "https://cf.bstatic.com/xdata/images/hotel/max1024x768/69233653.jpg?k=c8dd85b45348243e12e1435b22c253c470f5793c18b77d57f379a6041ce1ce5e&o=",
          "https://sea-princess.bangladeshhotels.net/data/Pics/OriginalPhoto/11984/1198418/1198418227/sea-princess-hotel-cox-s-bazar-pic-4.JPEG",
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfhZF6Iueo2bSu3dKLuRFLuoMYfPvHRhY-ag&s",
        ],
        logo: "https://hoteltheseaprincess.com/wp-content/uploads/2022/01/the-sea-princess-hotel.png",
        isCoupleFriendly: true,
        isGuestChoice: false,
        isDhoorbinChoice: true,
        facilities: [
          {
            id: 1,
            icon: parking,
            name: "Parking",
          },
          {
            id: 2,
            icon: smokeAlarm,
            name: "Smoke Alarm",
          },
          {
            id: 3,
            icon: airconditioned,
            name: "Air Conditioned",
          },
          {
            id: 4,
            icon: wifi,
            name: "Wifi",
          },
          {
            id: 4,
            icon: security,
            name: "Security",
          },
        ],
        status: true,
      },
      {
        id: 2,
        properyName: "Sea Pearl Beach Resort & Spa",
        location: "Cox's Bazar",
        country: "Bangladesh",
        propertyRating: 4,
        price: 5500,
        discount: 10,
        images: [
          "https://cf.bstatic.com/xdata/images/hotel/max1024x768/69233653.jpg?k=c8dd85b45348243e12e1435b22c253c470f5793c18b77d57f379a6041ce1ce5e&o=",
          "https://sea-princess.bangladeshhotels.net/data/Pics/OriginalPhoto/11984/1198418/1198418227/sea-princess-hotel-cox-s-bazar-pic-4.JPEG",
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfhZF6Iueo2bSu3dKLuRFLuoMYfPvHRhY-ag&s",
        ],
        logo: "https://hoteltheseaprincess.com/wp-content/uploads/2022/01/the-sea-princess-hotel.png",
        isCoupleFriendly: true,
        isGuestChoice: true,
        isDhoorbinChoice: false,
        facilities: [
          {
            id: 1,
            icon: parking,
            name: "Parking",
          },
          {
            id: 2,
            icon: smokeAlarm,
            name: "Smoke Alarm",
          },
          {
            id: 3,
            icon: airconditioned,
            name: "Air Conditioned",
          },
          {
            id: 4,
            icon: wifi,
            name: "Wifi",
          },
          {
            id: 4,
            icon: security,
            name: "Security",
          },
        ],
        status: true,
      },
      {
        id: 3,
        properyName: "Hotel Sea Princess",
        location: "Cox's Bazar",
        country: "Bangladesh",
        propertyRating: 4,
        price: 5500,
        discount: 10,
        images: [
          "https://cf.bstatic.com/xdata/images/hotel/max1024x768/69233653.jpg?k=c8dd85b45348243e12e1435b22c253c470f5793c18b77d57f379a6041ce1ce5e&o=",
          "https://sea-princess.bangladeshhotels.net/data/Pics/OriginalPhoto/11984/1198418/1198418227/sea-princess-hotel-cox-s-bazar-pic-4.JPEG",
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfhZF6Iueo2bSu3dKLuRFLuoMYfPvHRhY-ag&s",
        ],
        logo: "https://hoteltheseaprincess.com/wp-content/uploads/2022/01/the-sea-princess-hotel.png",
        isCoupleFriendly: true,
        isGuestChoice: false,
        isDhoorbinChoice: true,
        facilities: [
          {
            id: 1,
            icon: parking,
            name: "Parking",
          },
          {
            id: 2,
            icon: smokeAlarm,
            name: "Smoke Alarm",
          },
          {
            id: 3,
            icon: airconditioned,
            name: "Air Conditioned",
          },
          {
            id: 4,
            icon: wifi,
            name: "Wifi",
          },
          {
            id: 4,
            icon: security,
            name: "Security",
          },
        ],
        status: true,
      },
      {
        id: 4,
        properyName: "Hotel Sea Princess",
        location: "Cox's Bazar",
        country: "Bangladesh",
        propertyRating: 4,
        price: 5500,
        discount: 10,
        images: [
          "https://cf.bstatic.com/xdata/images/hotel/max1024x768/69233653.jpg?k=c8dd85b45348243e12e1435b22c253c470f5793c18b77d57f379a6041ce1ce5e&o=",
          "https://sea-princess.bangladeshhotels.net/data/Pics/OriginalPhoto/11984/1198418/1198418227/sea-princess-hotel-cox-s-bazar-pic-4.JPEG",
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfhZF6Iueo2bSu3dKLuRFLuoMYfPvHRhY-ag&s",
        ],
        logo: "https://hoteltheseaprincess.com/wp-content/uploads/2022/01/the-sea-princess-hotel.png",
        isCoupleFriendly: true,
        isGuestChoice: false,
        isDhoorbinChoice: true,
        facilities: [
          {
            id: 1,
            icon: parking,
            name: "Parking",
          },
          {
            id: 2,
            icon: smokeAlarm,
            name: "Smoke Alarm",
          },
          {
            id: 3,
            icon: airconditioned,
            name: "Air Conditioned",
          },
          {
            id: 4,
            icon: wifi,
            name: "Wifi",
          },
          {
            id: 4,
            icon: security,
            name: "Security",
          },
        ],
        status: true,
      },
    ],
  },
];
